import { render, staticRenderFns } from "./detailBase.vue?vue&type=template&id=f715d2d2&scoped=true&"
import script from "./detailBase.vue?vue&type=script&lang=js&"
export * from "./detailBase.vue?vue&type=script&lang=js&"
import style0 from "./detailBase.vue?vue&type=style&index=0&id=f715d2d2&lang=sass&scoped=true&"
import style1 from "./detailBase.vue?vue&type=style&index=1&id=f715d2d2&lang=scss&scoped=true&"
import style2 from "./detailBase.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715d2d2",
  null
  
)

export default component.exports